/**
 * Code d'îlot.
 *
 * Règle non négociable n° 5 : c'est la **seule** identification d'un groupe
 * d'élèves. Pas de nom, pas d'email. Six caractères, dans un alphabet sans
 * ambiguïté à l'oral ni à la lecture — ni 0/O, ni 1/I/L — parce qu'un élève
 * recopie ce code depuis une étiquette papier.
 */

/** Alphabet du code d'îlot : 26 lettres moins O, I, L ; 10 chiffres moins 0, 1. */
export const ISLAND_CODE_ALPHABET = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';

export const ISLAND_CODE_LENGTH = 6;

const ISLAND_CODE_PATTERN = new RegExp(`^[${ISLAND_CODE_ALPHABET}]{${ISLAND_CODE_LENGTH}}$`);

/** Le code est-il bien formé ? Ne dit pas s'il existe : le moteur ne connaît pas les classes. */
export function isValidIslandCode(code: string): boolean {
  return ISLAND_CODE_PATTERN.test(code);
}

/**
 * Fabrique un code d'îlot.
 *
 * Le générateur aléatoire est un paramètre : le moteur reste pur et le test
 * reste déterministe. En production, passer une source cryptographique.
 */
export function createIslandCode(random: () => number): string {
  let code = '';
  for (let index = 0; index < ISLAND_CODE_LENGTH; index += 1) {
    const position = Math.floor(random() * ISLAND_CODE_ALPHABET.length);
    code += ISLAND_CODE_ALPHABET[position] ?? ISLAND_CODE_ALPHABET[0];
  }
  return code;
}
